const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const UpdateCodes = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CODES_UPDATE_REQUEST":
      return { loading: true, error: false, data: [] };
    case "CODES_UPDATE_ERROR":
      return { loading: false, error: true, data: [] };
    case "CODES_UPDATE_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "CODES_UPDATE_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default UpdateCodes;
